module.exports = __webpack_public_path__ + "static/img/icon.99de9cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/client/terminal-download/imgs/icon.png
// module id = k6ng
// module chunks = 2